import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import { sessionExpiryMinute } from '../config';
import { getMinute, history, isUserLoggedIn, Logout } from "./handler";
export const SessionManger: any = () => {

    const [events] = useState(['click', 'load', 'scroll']);
    let warningInactiveInterval: any = useRef();
    let startTimerInterval: any = useRef();

    let timeChecker = () => {
        let storedTimeStamp = localStorage.getItem('lastTimeStamp');
        clearTimeout(startTimerInterval.current);

        if (storedTimeStamp) {
            startTimerInterval.current = setTimeout(() => {
                if (isUserLoggedIn()) {
                    Logout()
                    window.location.reload();
                }
                // Warning 2 min before logout
                // warningInactive(storedTimeStamp);
        }, getMinute(sessionExpiryMinute));
        } else {
            clearTimeout(startTimerInterval.current);
            clearInterval(warningInactiveInterval.current);
        }
    };

    // let warningInactive = (timeString: any) => {
    //     clearTimeout(startTimerInterval.current);

    //     warningInactiveInterval.current = setInterval(() => {
    //         const maxTime = 2; // Maximum ideal time given before Logout 
    //         const popTime = 1; // remaining time (notification) left to Logout.

    //         const diff = moment.duration(moment().diff(moment(timeString)));
    //         const minPast = diff.minutes();
    //         const leftSecond = 60 - diff.seconds();
    //         if (minPast === popTime) {
    //             setSecond(leftSecond);
    //         }

    //         if (minPast === maxTime) {
    //             clearInterval(warningInactiveInterval.current);
    //             localStorage.removeItem('lastTimeStamp');
    //             // your Logout function here
    //             Logout()
    //         }
    //     }, 1000);
    // };

    let resetTimer = useCallback(() => {
        clearTimeout(startTimerInterval.current);
        clearInterval(warningInactiveInterval.current);
        if (isUserLoggedIn()) {
            let timeStamp: any = moment();
            localStorage.setItem('lastTimeStamp', timeStamp);
        } else {
            clearInterval(warningInactiveInterval.current);
            localStorage.removeItem('lastTimeStamp');
        }
        timeChecker();
    }, []);


    useEffect(() => {
        events.forEach((event) => {
            window.addEventListener(event, resetTimer);
        });
        history.listen(() => {
            resetTimer()
        });
        // Run the timeChecker
        timeChecker();
    }, [resetTimer, events]);

}
